import createConverter from './lib/create_converter';
import Customer from 'models/customer';

export default createConverter(Customer);
